import type { IExpoImageBlurConfig } from '@/utils/expoImageBlur';

/** Platform blur strengths for locked / sensitive thumbnails and avatars. */
export const LOCKED_CONTENT_BLUR: IExpoImageBlurConfig = {
  iosBlurRadius: 22,
  webBlurRadius: 4,
  androidCssBlurPx: 4,
};
